import { useContext } from 'react';
import { ModeContext } from '../context/Mode.context';

const useMode = () => useContext(ModeContext);
export default useMode;
